import i18next from "i18next";
import { toast } from "react-toastify";

import { shutterbDashboardServices } from "../../services";
import {
  VIDEO_EXTENSIONS,
  MEDIA_MIME_TYPES,
  customerConstants,
  globalSystemConstants,
  initialWorkingSchedules,
  shutterbDashboardConstants,
  messages,
  ONE_THOUSAND,
} from "../../constants";
import {
  customToast,
  errorHandler,
  convertBytesToMbs,
  calculateTotalFileSizeInMbs,
  convertEpochToTimezoneMillis,
} from "../../shared/utility";
import { success, failure, custom } from "./utilities";

const {
  IS_UPDATED,
  ADD_TO_PROFILE,
  ADD_TO_GALLERY,
  GET_REEL_DETAILS,
  GET_GALLERY_DATA,
  DELETE_FROM_GALLERY,
  FAVORITE_GALLERY_CLIP,
  GET_EVENT_DETAIL_BY_ID,
  GET_REELS_BY_EVENT_ID,
  GET_REELS_BY_EVENT_GROUP_ID,
} = shutterbDashboardConstants;

// Event request tab actions------------------------------
const eventRequests = (id) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getEventRequests(id)
      .then(
        (response) => {
          dispatch(
            success(response, shutterbDashboardConstants.GET_EVENT_REQUEST)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_EVENT_REQUEST)
          );
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const updateEventRequest = (id, dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .putEventRequests(id, dataObj)
      .then(
        (response) => {
          if (dataObj.isActive) {
            customToast(
              i18next.t("event_request_accepted"),
              toast.TYPE.SUCCESS
            );
          } else {
            customToast(
              i18next.t("event_request_declined"),
              toast.TYPE.SUCCESS
            );
          }
          dispatch(
            success(response, shutterbDashboardConstants.PUT_EVENT_REQUEST)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_EVENT_REQUEST)
          );
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

// My Events tab actions----------------------------------
const sbMyEvents = (id, status) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getSbMyEvents(id, status)
      .then(
        (response) => {
          dispatch(
            success(response, shutterbDashboardConstants.GET_SB_MY_EVENTS)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const updateSbMyEventsStatus = (
  eventId,
  dataObj,
  sbUserId,
  goToPreviousPage
) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .putSbMyEventsStatus(eventId, dataObj)
      .then(
        (response) => {
          dataObj.checkedStatus === shutterbDashboardConstants.CHECK_OUT
            ? customToast(
                i18next.t("successfully_checked_out"),
                toast.TYPE.SUCCESS
              )
            : customToast(
                i18next.t("successfully_checked_in"),
                toast.TYPE.SUCCESS
              );
          if (typeof goToPreviousPage === "boolean") {
            window.location.reload();
          }
          dispatch(sbMyEvents(sbUserId, customerConstants.UPCOMING_EVENTS));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getEventDetailByEventId = (eventId) => {
  return (dispatch) => {
    dispatch(
      custom(GET_EVENT_DETAIL_BY_ID, globalSystemConstants.SPINNER_ACTIVATE)
    );
    shutterbDashboardServices
      .getEventDetailByEventId(eventId)
      .then(
        (response) => {
          dispatch(custom(response, GET_EVENT_DETAIL_BY_ID));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_EVENT_DETAIL_BY_ID,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

// My profile tab actions---------------------------------
const mySchedule = (
  id,
  setDistanceValue,
  setBlackoutDays,
  setWorkingSchedules
) => {
  // action does not use reducer, it updates the component's local state
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getMySchedule(id)
      .then(
        (response) => {
          setDistanceValue(response.travelDistance.distanceToTravel);
          setBlackoutDays({
            displayDates: response.holidayProfile.map(
              (e) =>
                convertEpochToTimezoneMillis(e.date, response.sourceTimeZone) *
                ONE_THOUSAND
            ),
            holidayDetails: response.holidayProfile.map((e) => {
              return {
                date: convertEpochToTimezoneMillis(
                  e.date,
                  response.sourceTimeZone
                ),
                dateTo: e.dateTo,
                startTime: convertEpochToTimezoneMillis(
                  e.startTime,
                  response.sourceTimeZone
                ),
                endTime: convertEpochToTimezoneMillis(
                  e.endTime,
                  response.sourceTimeZone
                ),
              };
            }),
          });
          if (response.workingSchedules.length !== 0) {
            setWorkingSchedules(
              JSON.parse(JSON.stringify([...response.workingSchedules]))
            );
          } else {
            setWorkingSchedules(
              JSON.parse(JSON.stringify([...initialWorkingSchedules]))
            );
          }
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const updateMySchedule = (id, dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .putMySchedule(id, dataObj)
      .then(
        (response) => {
          customToast(i18next.t("saved_successfully"), toast.TYPE.SUCCESS);
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const myPortfolio = (id, setImages, isPortfolioUpdated) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getPortfolioRequests(id)
      .then(
        (response) => {
          const data = response.items?.gallery;
          if (data && data.length > 0) {
            if (isPortfolioUpdated) {
              window.location.reload(true);
            }

            const updatedFiles = data.map((file) => {
              return {
                ...file,
                name: file.imageUrl && file.imageUrl.slice(0, -4),
                url: `${process.env.REACT_APP_S3_BASE_URL_PORTFOLIO}/${file.imageUrl}`,
                thumbnailUrl: file?.imageThumbnailUrl
                  ? `${process.env.REACT_APP_S3_BASE_URL_PORTFOLIO}/${file.imageThumbnailUrl}`
                  : null,
              };
            });

            setImages(
              updatedFiles.map((file) => {
                let fileType;
                if (
                  VIDEO_EXTENSIONS.MP4.some((ext) =>
                    file.imageUrl.endsWith(ext)
                  )
                ) {
                  fileType = MEDIA_MIME_TYPES.MP4;
                } else if (
                  VIDEO_EXTENSIONS.MOV.some((ext) =>
                    file.imageUrl.endsWith(ext)
                  )
                ) {
                  fileType = MEDIA_MIME_TYPES.MOV;
                } else if (
                  VIDEO_EXTENSIONS.M4V.some((ext) =>
                    file.imageUrl.endsWith(ext)
                  )
                ) {
                  fileType = MEDIA_MIME_TYPES.M4V;
                } else {
                  fileType = MEDIA_MIME_TYPES.JPEG;
                }
                return {
                  file: new File([file], file.name, {
                    type: fileType,
                    lastModified: file.lastModified,
                    lastModifiedDate: file.lastModifiedDate,
                  }),
                  url: file.url,
                  thumbnailUrl: file.thumbnailUrl,
                  contentType: file?.contentType,
                  id: file.id,
                  sbportfolioId: file.sbportfolioId,
                  imageUrl: file.imageUrl,
                };
              })
            );
          }
          dispatch(
            success(response, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const deleteImg = (dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .deletePortfolioImgRequests(dataObj)
      .then(
        (response) => {
          customToast(
            i18next.t("img_successfully_deleted"),
            toast.TYPE.SUCCESS
          );
          dispatch(
            success(response, shutterbDashboardConstants.DELETE_IMG_REQUEST)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const updateMyPortfolio = (id, dataObj, setProfileImgToShow, setImages) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .putPortfolioRequests(id, dataObj)
      .then(
        (response) => {
          let isPortfolioUpdated = true;
          customToast(i18next.t("saved_successfully"), toast.TYPE.SUCCESS);
          setProfileImgToShow({});
          dispatch(myPortfolio(id, setImages, isPortfolioUpdated));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const myInfo = (id) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getMyInfoRequests(id)
      .then(
        (response) => {
          dispatch(
            success(response, shutterbDashboardConstants.GET_MY_INFO_REQUEST)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          // can dispatch actions to handle error ie logout
        }
      )
      .finally(() => {
        // Turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const updateMyInfo = (id, dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .putMyInfoRequests(id, dataObj)
      .then(
        (response) => {
          customToast(i18next.t("saved_successfully"), toast.TYPE.SUCCESS);
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const stripeConnection = (id) => {
  return (dispatch) => {
    shutterbDashboardServices
      .getStripeConnectionRequest(id)
      .then(
        (response) => {
          window.location.replace(response);
        },
        (error) => {
          customToast(i18next.t("unable_to_access_server"), toast.TYPE.ERROR);
          dispatch(
            failure(error, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const stripeConnectedStatus = (id) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getStripeConnectedStatusRequest(id)
      .then(
        (response) => {
          dispatch(
            success(
              response,
              shutterbDashboardConstants.GET_STRIPE_CONNECTED_STATUS_REQUEST
            )
          );
        },
        (error) => {
          customToast(i18next.t("unable_to_access_server"), toast.TYPE.ERROR);
          dispatch(
            failure(error, shutterbDashboardConstants.GET_PORTFOLIO_REQUEST)
          );
        }
      )
      .finally(() => {
        // turn off the spinner
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const deleteFromGallery = (data) => {
  return (dispatch) => {
    dispatch(
      custom(DELETE_FROM_GALLERY, globalSystemConstants.SPINNER_ACTIVATE)
    );
    shutterbDashboardServices
      .deleteFromGallery(data)
      .then(
        (response) => {
          dispatch(success(response, DELETE_FROM_GALLERY));
          customToast(
            i18next.t("img_successfully_deleted"),
            toast.TYPE.SUCCESS
          );
        },
        (error) => {
          customToast(
            i18next.t(error[0] === undefined ? "undefined" : error[0]),
            toast.TYPE.ERROR
          );
          dispatch(failure(error, DELETE_FROM_GALLERY));
        }
      )
      .finally(() => {
        dispatch(
          custom(DELETE_FROM_GALLERY, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getGalleryData = (data) => {
  return (dispatch) => {
    dispatch(custom(GET_GALLERY_DATA, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getGalleryData(data)
      .then(
        (response) => {
          dispatch(success(response, GET_GALLERY_DATA));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(i18next.t(error[0]), toast.TYPE.ERROR);
          dispatch(failure(error, GET_GALLERY_DATA));
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_GALLERY_DATA, globalSystemConstants.SPINNER_DIACTIVATE)
        );
        dispatch(
          custom(GET_GALLERY_DATA, globalSystemConstants.OVERLAY_DIACTIVATE)
        );
      });
  };
};

const addToGallery = (
  data,
  options,
  sbUserId = 0,
  counterFilesUploaded,
  setCounterFilesUploaded = null,
  totalUploadedFileSize = null,
  setTotalFileSizeToUpload = null,
  currentFilePrevUploadedSizeRef = null,
  setCurrentFileName = "",
  setCurrentFileSize = ""
) => {
  const files = Array.from(data.entries()).filter(
    (entry) => entry[0] === "file" && entry[1] instanceof File
  );
  const extractedEventId = data.get("eventId");
  const extractedSbUserId = data.get("SbUserId");

  const images = [];
  const videos = [];

  files.forEach((file) => {
    const fileObject = file[1];
    if (fileObject.type && fileObject.type.startsWith("video/")) {
      videos.push(fileObject);
    } else {
      images.push(fileObject);
    }
  });

  setTotalFileSizeToUpload(
    calculateTotalFileSizeInMbs(videos) + calculateTotalFileSizeInMbs(images)
  );

  return async (dispatch) => {
    try {
      // Make API calls for videos sequentially
      for (const video of videos) {
        currentFilePrevUploadedSizeRef.current = 0;
        setCurrentFileName(video.name);
        setCurrentFileSize(convertBytesToMbs(video.size).toFixed(2));
        const videoFormData = new FormData();
        videoFormData.append(`file`, video);
        videoFormData.append("eventId", extractedEventId);
        videoFormData.append("SbUserId", extractedSbUserId);
        videoFormData.append("contentType", "file");

        const videoResponse = await shutterbDashboardServices.addToGallery(
          videoFormData,
          options
        );
        if (counterFilesUploaded) {
          setCounterFilesUploaded((prevCount) => prevCount + 1);
        }
        console.log("Video response:", videoResponse);
      }

      // Make API calls for images sequentially
      for (const image of images) {
        currentFilePrevUploadedSizeRef.current = 0;
        setCurrentFileName(image.name);
        setCurrentFileSize(convertBytesToMbs(image.size).toFixed(2));
        const imageFormData = new FormData();
        imageFormData.append(`file`, image);
        imageFormData.append("eventId", extractedEventId);
        imageFormData.append("SbUserId", extractedSbUserId);
        imageFormData.append("contentType", "file");

        const imageResponse = await shutterbDashboardServices.addToGallery(
          imageFormData,
          options
        );
        if (counterFilesUploaded) {
          setCounterFilesUploaded((prevCount) => prevCount + 1);
          totalUploadedFileSize += convertBytesToMbs(image.size);
        }
        console.log("Image response:", imageResponse);
      }

      // Handle success for images and videos
      sbUserId && dispatch(getReelEvents(sbUserId));
      customToast("Added to gallery successfully", toast.TYPE.SUCCESS);

      const object = {};
      for (let [key, value] of data.entries()) {
        if (key === "SbUserId") {
          key = "sbUserId";
          value = parseInt(value);
        }
        if (key === "eventId") {
          // value = parseInt(value);
        }
        object[key] = value;
      }
      dispatch(getGalleryData(object));
    } catch (error) {
      console.error("Error in addToGallery:", error);
      Array.isArray(error) &&
        customToast(i18next.t(error[0]), toast.TYPE.ERROR);
      dispatch(failure(error, ADD_TO_GALLERY));

      const object = {};
      for (let [key, value] of data.entries()) {
        if (key === "SbUserId") {
          key = "sbUserId";
          value = parseInt(value);
        }
        if (key === "eventId") {
        }
        object[key] = value;
      }
      dispatch(getGalleryData(object));

      throw error;
    }
  };
};

const addToProfile = (data, options) => {
  return (dispatch) => {
    dispatch(custom(ADD_TO_PROFILE, globalSystemConstants.SPINNER_DIACTIVATE));
    dispatch(custom(ADD_TO_PROFILE, globalSystemConstants.OVERLAY_ACTIVATE));
    shutterbDashboardServices
      .addToProfile(data, options)
      .then(
        (response) => {
          customToast("Added to profile successfully", toast.TYPE.SUCCESS);
          dispatch(success(response, ADD_TO_PROFILE));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(i18next.t(error[0]), toast.TYPE.ERROR);
          dispatch(failure(error, ADD_TO_PROFILE));
        }
      )
      .finally(() => {
        dispatch(
          custom(ADD_TO_PROFILE, globalSystemConstants.SPINNER_DIACTIVATE)
        );
        dispatch(
          custom(ADD_TO_PROFILE, globalSystemConstants.OVERLAY_DIACTIVATE)
        );
      });
  };
};

const isFileDeleted = () => {
  return (dispatch) => {
    dispatch(custom(null, shutterbDashboardConstants.IS_FILE_DELETED));
  };
};

const getReelEvents = (sbUserId, status, pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getReelEvents(sbUserId, status, pageNumber, pageSize)
      .then(
        (response) => {
          dispatch(custom(response, globalSystemConstants.TOTAL_COUNT));
          dispatch(
            success(response, shutterbDashboardConstants.GET_REEL_EVENTS)
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const downloadAssets = (orderItemId, sbUserName) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .downloadAssets(orderItemId, sbUserName)
      .then(
        (message) => {
          toast.success(i18next.t("download_files_email"), {
            autoClose: 5000,
            hideProgressBar: true,
          });
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const addReelsToGallery = (data, options, onSuccess) => {
  return (dispatch) => {
    dispatch(custom(ADD_TO_GALLERY, globalSystemConstants.OVERLAY_ACTIVATE));
    shutterbDashboardServices
      .addToGallery(data, options)
      .then(
        (response) => {
          // in case of reel
          if (onSuccess) {
            onSuccess(true);
          }
          customToast("Recap added successfully", toast.TYPE.SUCCESS);
          dispatch(setIsUpdated(true));
        },
        (error) => {
          onSuccess(false);
          Array.isArray(error) &&
            customToast(i18next.t(error[0]), toast.TYPE.ERROR);
          dispatch(failure(error, ADD_TO_GALLERY));
        }
      )
      .finally(() => {
        dispatch(
          custom(ADD_TO_GALLERY, globalSystemConstants.OVERLAY_DIACTIVATE)
        );
      });
  };
};

const getReelDetails = (eventId) => {
  return (dispatch) => {
    dispatch(custom(GET_REEL_DETAILS, globalSystemConstants.SPINNER_ACTIVATE));
    shutterbDashboardServices
      .getReelDetails(eventId)
      .then(
        (response) => {
          // in case of reel
          dispatch(success(response, GET_REEL_DETAILS));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(i18next.t(error[0]), toast.TYPE.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_REEL_DETAILS, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const setIsUpdated = (data) => {
  return (dispatch) => {
    dispatch(custom(data, IS_UPDATED));
  };
};

// Favorite gallery clip
const favoriteClip = (clipId, getUpdatedData) => {
  return (dispatch) => {
    dispatch(
      custom(FAVORITE_GALLERY_CLIP, globalSystemConstants.SPINNER_ACTIVATE)
    );
    shutterbDashboardServices
      .favoriteClip(clipId)
      .then(
        (response) => {
          // Call only on success
          if (getUpdatedData) {
            getUpdatedData();
          }
        },
        (error) => {
          customToast(
            i18next.t(error[0] === undefined ? "undefined" : error[0]),
            toast.TYPE.ERROR
          );
          dispatch(failure(error, FAVORITE_GALLERY_CLIP));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            FAVORITE_GALLERY_CLIP,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const resetSbMyEvents = () => {
  return (dispatch) => {
    dispatch(custom(null, shutterbDashboardConstants.TAb_CHANGED));
  };
};

const getChangeRequestReelEvents = (sbUserId, pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(
      custom(
        shutterbDashboardConstants.GET_CHANGE_REQUEST_REEL_EVENTS,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    shutterbDashboardServices
      .getChangeRequestReelEvents(sbUserId, pageNumber, pageSize)
      .then(
        (response) => {
          dispatch(custom(response, globalSystemConstants.TOTAL_COUNT));
          dispatch(
            success(
              response,
              shutterbDashboardConstants.GET_CHANGE_REQUEST_REEL_EVENTS
            )
          );
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shutterbDashboardConstants.GET_CHANGE_REQUEST_REEL_EVENTS,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const addShutterbChangeRequestReelEvent = (
  data,
  sbUserId,
  pageNumber,
  pageSize,
  setIsSuccessful
) => {
  return (dispatch) => {
    dispatch(
      custom(
        shutterbDashboardConstants.ADD_SHUTTERB_CHANGE_REQUEST_REEL_EVENT,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    shutterbDashboardServices
      .addShutterbChangeRequestReelEvent(data)
      .then(
        () => {
          dispatch(resetSbMyEvents());
          setIsSuccessful(true);
          customToast(messages.UPLOADED_SUCCESSFULLY, toast.TYPE.SUCCESS);
          dispatch(getChangeRequestReelEvents(sbUserId, pageNumber, pageSize));
        },
        (error) => {
          Array.isArray(error) &&
            customToast(
              i18next.t(error[0] === undefined ? "undefined" : error[0]),
              toast.TYPE.ERROR
            );
          dispatch(
            failure(error, shutterbDashboardConstants.GET_EVENT_REQUEST)
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shutterbDashboardConstants.ADD_SHUTTERB_CHANGE_REQUEST_REEL_EVENT,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const getReelsByEventId = (eventId) => {
  return (dispatch) => {
    dispatch(
      custom(GET_REELS_BY_EVENT_ID, globalSystemConstants.SPINNER_ACTIVATE)
    );
    shutterbDashboardServices
      .getReelsByEventId(eventId)
      .then(
        (response) => {
          dispatch(success(response, GET_REELS_BY_EVENT_ID));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_REELS_BY_EVENT_ID,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const getReelsByEventGroupId = (eventGroupId) => {
  return (dispatch) => {
    dispatch(
      custom(
        GET_REELS_BY_EVENT_GROUP_ID,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    shutterbDashboardServices
      .getReelsByEventGroupId(eventGroupId)
      .then(
        (response) => {
          dispatch(success(response, GET_REELS_BY_EVENT_GROUP_ID));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_REELS_BY_EVENT_GROUP_ID,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

// exporting all shutterb dashboard actions
export const shutterbDashboardActions = {
  eventRequests,
  updateEventRequest,
  sbMyEvents,
  updateSbMyEventsStatus,
  mySchedule,
  updateMySchedule,
  myPortfolio,
  deleteImg,
  updateMyPortfolio,
  myInfo,
  updateMyInfo,
  stripeConnection,
  stripeConnectedStatus,
  deleteFromGallery,
  getGalleryData,
  addToGallery,
  addToProfile,
  isFileDeleted,
  getReelEvents,
  downloadAssets,
  addReelsToGallery,
  getReelDetails,
  getEventDetailByEventId,
  setIsUpdated,
  favoriteClip,
  resetSbMyEvents,
  getChangeRequestReelEvents,
  addShutterbChangeRequestReelEvent,
  getReelsByEventId,
  getReelsByEventGroupId,
};
